module.exports = __webpack_public_path__ + "static/media/WheatStage107.8747c0c4.PNG";